import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck, faStop
} from "@fortawesome/free-solid-svg-icons";


export function ScoreContainer(props) {
  const { resultObj } = props;
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><FontAwesomeIcon className='' icon={faCheck} /></div>
  const result = resultObj?.result;
  const dataTechCode = resultObj?.wlt === 'W' ? resultObj?.extra?.techCode ? resultObj.extra?.techCode : '' : '';
  const dataH = resultObj?.extra?.totH;
  const dataX = resultObj?.extra?.totX;
  const dataS3 = resultObj?.extra?.totS3;
  const dataS = parseInt(resultObj?.extra?.totS);
  let dataPenalties
  if (dataS > 0) {
    for (let i = 0; i < dataS; i++) {
      dataPenalties = <>{dataPenalties} <FontAwesomeIcon className='icon-yellow' icon={faStop} /></>
    }
  } else if (dataH === '1' || dataX === '1' || dataS3 === '1') {
    dataPenalties = <FontAwesomeIcon className='icon-red' icon={faStop} />
  }

  return (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center'>
      <div className="align-self-center row w-100 m-0">
        <div className='col-2 p-0 small'>
          {winner}
        </div>
        <div className={`col p-0 text-end ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
          {result}
        </div>
        <div className='col p-0'>
          {dataPenalties}
        </div>
        <div className='col p-0'>
          {dataTechCode}
        </div>
      </div>
    </div>
  )
}
